var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 7.5,
    fill: "white",
    stroke: "#592EE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8685 22.8896C24.8685 22.0696 25.5485 21.5896 26.6485 21.5896C27.7485 21.5896 28.5485 22.1896 28.8285 23.1296L32.5085 22.5496C32.3485 20.9296 31.0485 19.5896 29.2485 18.9496L30.3285 15.8496H26.4685L26.3085 18.5496C23.0285 18.7096 20.9685 20.5096 20.9685 23.2296C20.9685 27.6096 27.4685 26.9496 27.4685 29.0696C27.4685 29.9496 26.6885 30.4496 25.4485 30.4496C24.2685 30.4496 23.3085 29.7296 23.1085 28.6496L19.4885 29.1696C19.7285 31.1096 21.1285 32.5696 23.1685 33.1696L22.1085 36.1496H25.9685L26.1885 33.4096C29.4485 33.1296 31.5085 31.3696 31.5085 28.7696C31.5085 24.3096 24.8685 25.2896 24.8685 22.8896Z",
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayTeam);
export default __webpack_public_path__ + "static/media/pay_team.e7f09e601a8243b77a1ac7cbbeeff63b.svg";
export { ForwardRef as ReactComponent };